/* src/modules/course_approvals/cards/AddCourses/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 44,
    overflow: 'auto',
  },
  padding: {
    padding: theme.spacing.unit * 3,
  },
  form: {
    width: theme.spacing.unit * 30,
    marginTop: theme.spacing.unit * 3,
  },
  coursesInput: {
    flex: 1,
    marginBottom: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 3,
  },
  adornment: {
    bottom: 8,
  },
  alarmIcon: {
    marginRight: theme.spacing.unit,
  },
  buttonContainer: {
    paddingTop: theme.spacing.unit * 3,
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  instructions: {
    marginLeft: theme.spacing.unit * 6,
  },
});



// WEBPACK FOOTER //
// ./src/modules/course_approvals/cards/AddCourses/styles.js